import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Pricing from "@/components/site/Pricing";
import Faq from "@/components/site/Faq";
import LeadForm from "@/components/site/LeadForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Navbar />
      <Hero />
      <Services />
      <Pricing />
      <Gallery />
      <Testimonials />
      <Faq />
      <LeadForm />
      <Footer />
    </main>
  );
}
